module.exports = __webpack_public_path__ + "img/eq-shako.0d5d6f95.png";